import React from 'react'
import Modal from 'components/modal'
import 'less/edit-survey-id-modal.less' 


const  ConfirmEditSurveyIdModal = props => {
  return (
    <Modal
        title={"EDIT SURVEY ID"}
        isOpen={props.isOpen}
        className="confirmation-modal edit-survey-id-modal"
        type="modal"
        autoFocusSubmit={false}
        submitBtnText="Save and Confirm"
        onCancel={props.onClose}
        onSubmit= {() => props.editSurveyId({projectId: props.currentProject.id, editedSurveyId: props.editedSurveyId})}
        isSubmitting= {props.isSubmitting}
      >
        <div className="edit-survey-id-modal-body">
          <div className="edit-survey-id-modal-text">
            <p>
              {props.t('edit.survey.id.confirmation.messgae')}
            </p>
          </div>
        </div>
      </Modal>
    )
}

export default ConfirmEditSurveyIdModal
